import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import MDIGITAL_FORM_STATE from "./MDIGITAL_FORM_STATE";
import MDIGITAL_CONFIGURATION from "./MDIGITAL_CONFIGURATION";

var extensionActions = ["updateProfileFromExtension","clearProfileFromExtension"];

  function init() {
    //create an event lisener to get data about the actions in the invite iframe
    KAMPYLE_UTILS.setEventHandler(window, 'message', handleMessage);
  }

  function isAllowedSource(source) {
    var iframeConsts = KAMPYLE_CONSTANT.IFRAME_SETTINGS;
    var iframeIds = [
      iframeConsts.EMBEDDED.IFRAME_ID_PREFIX,
      iframeConsts.LIGHTBOX.IFRAME_ID_PREFIX,
      iframeConsts.INVITATION.IFRAME_ID,
      iframeConsts.ANIMATION.IFRAME_ID,
      iframeConsts.PREVIEW.IFRAME_ID
    ]
    for (var i = 0; i < iframeIds.length; i++) {
      var iframeElements = document.querySelectorAll('iframe[id^="' + iframeIds[i] + '"]');
      for (var idx = 0; idx < iframeElements.length; idx++) {
        if (source === iframeElements[idx].contentWindow) {
          return true;
        }
      }
    }
    var popupHandler = KAMPYLE_DATA.getMemoryData('popupHandler');
    if (popupHandler && popupHandler === source) {
      return true;
    }
    return false;
  }

  function validateMessageEvent(e) {
    if(KAMPYLE_UTILS.isDebugMode()){
      return true;
    }
    var isSourceCheckEnabled = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_ONSITE_POST_MESSAGE_VERIFICATION);
    //Make sure the event came from a Kampyle domain
    if (!e || !e.origin || !e.data || isSourceCheckEnabled && (!e.source || !isAllowedSource(e.source))) {
      return false;
    }

    var parsedData = JSON.parse(e.data);
    var isExtensionEnabled = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.EXTENSION_ENABLED);
    if (isExtensionEnabled && parsedData && extensionActions.includes(parsedData.action)) {
      return true;
    }

    var formData = KAMPYLE_DATA.getFormData(parsedData.formId);
    if(formData && formData.formHtmlUrl && KAMPYLE_UTILS.getParsedUrl(formData.formHtmlUrl).origin !== e.origin) {
      return false
    }

    //ON_PREM_HYBRID condition is for customers that send messages via other urls because they have on prem
    var baseUrl = KAMPYLE_CONSTANT.PLACEHOLDERS.URL_PREFIX;

    if (baseUrl.indexOf("://") > -1) {
      var baseUrlSplitted = baseUrl.split('/');
      baseUrl = baseUrlSplitted[0] + "//" + baseUrlSplitted[2];
    } else {
      var indexOfFirstSlash = baseUrl.indexOf("/");
      if (indexOfFirstSlash > -1) {
        baseUrl = baseUrl.slice(0, indexOfFirstSlash)
      }
    }

    return KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ON_PREM_HYBRID) || e.origin === baseUrl;
  }

  function handleMessage(e) {
    var data;
    try {//TODO check if e.data is a string or an object
      data = JSON.parse(e.data);
    }
    catch (e) {
      return false;
    }

    if (!validateMessageEvent(e)) {
      return false;
    }
    var feedbackCorrelationUUID = data.feedbackCorrelationUUID;
    var onsiteConfiguration = MDIGITAL_CONFIGURATION.getOnsiteConfiguration();

    switch (data.action) {

      case 'inviteAccepted':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_inviteAccepted', { 'formId': data.formId });
        break;
      case 'inviteDeclined':
      case 'inviteDefered':
        //hide the invite dialog
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_inviteDeclined', { 'formId': data.formId });
        break;
      case 'inviteHeightChanged':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_inviteHeightChanged', {
          formId: data.formId,
          newHeight: data.newHeight,
        });
        break;
      case 'heightRatioChange':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_heightRatioChange', {
          formId: data.formId,
          heightRatio: data.heightRatio,
        });
        break;
      case 'formLoaded':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_formLoaded', {
          'formId': data.formId,
          origin: e.origin,
          isScreenCaptureEnabled: data.isScreenCaptureEnabled,
        });
        break;
      case 'formSubmitPending':
      case 'formHide':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_formHide', { 'formId': data.formId });
        break;
      case 'formSubmitted':
        var payload = {
          formId: data.formId,
          feedbackUUID: data.feedbackUUID,
          feedbackCorrelationUUID: feedbackCorrelationUUID
        };
        if(data && data.formLanguage){
            payload.formLanguage = data.formLanguage;
        }
        if (KAMPYLE_FUNC.isContentPayloadEnabled() && data.content) {
            payload.content = data.content;
        }
        if (data.isAutoAction) {
          payload.isAutoAction = data.isAutoAction;
        }
        if (onsiteConfiguration && onsiteConfiguration.digitalUnitId) {
            payload.digitalUnitId = onsiteConfiguration.digitalUnitId;
        }
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_feedbackSubmitted', payload);
        break;
      case 'formPreSubmitted':
        var payload = {
          formId: data.formId,
          feedbackCorrelationUUID: feedbackCorrelationUUID
        };
        if(data && data.formLanguage){
          payload.formLanguage = data.formLanguage;
        }
        if (KAMPYLE_FUNC.isContentPayloadEnabled() && data.content) {
          payload.content = data.content;
        }
        if (data.isAutoAction) {
          payload.isAutoAction = data.isAutoAction;
        }
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_feedbackPreSubmitted', payload);
        break;
      case 'formPostSubmitted':
        var payload = {
          formId: data.formId,
          feedbackUUID: data.feedbackUUID,
          feedbackCorrelationUUID: feedbackCorrelationUUID
        };
        if(data && data.formLanguage){
          payload.formLanguage = data.formLanguage;
        }
        if (KAMPYLE_FUNC.isContentPayloadEnabled() && data.content) {
          payload.content = data.content;
        }
        if (onsiteConfiguration && onsiteConfiguration.digitalUnitId) {
          payload.digitalUnitId = onsiteConfiguration.digitalUnitId;
        }
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_feedbackPostSubmitted', payload);
        break;
      case 'formClose':
        var payload = {
            formId: data.formId,
            feedbackUUID: data.feedbackUUID,
            sourceWindow: e.source,
            isFormSubmitted: data.isFormSubmitted,
            feedbackCorrelationUUID: feedbackCorrelationUUID
        };
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_formClosed', payload);
        break;
      case 'formPageShown':
        var payload = {
          'formId': data.formId,
          'pageNumber': data.pageNumber,
          feedbackCorrelationUUID: feedbackCorrelationUUID
        };
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_formPageShown', payload);
        break;
      case 'triggerScreenCapture':
        var payload = {
          'formId': data.formId,
          'screenCaptureSettings': data.screenCaptureSettings,
          feedbackCorrelationUUID: feedbackCorrelationUUID,
          screenCaptureUuid: KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.USER_SNAP_AS_COMPONENT) ? data.screenCaptureUuid : null
        }

        if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":true,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isScreenCaptureEnabled) {
          KAMPYLE_EVENT_DISPATCHER.trigger('neb_captureInit', payload);
        }

        break;
      case 'screenCaptureDelete':
        KAMPYLE_EVENT_DISPATCHER.trigger('screenCaptureDelete', data);
        break;
      case 'screenCaptureRetake':
        KAMPYLE_EVENT_DISPATCHER.trigger('screenCaptureRetake', data);
        break;
      case 'scrollToForm':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_scrollToForm', { formId: data.formId });
        break;

      case 'iFrameHeightChanged':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_iFrameHeightChanged', {
          formId: data.formId,
          newHeight: data.newHeight,
        });
        break;

      case 'scrollToTop':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_scrollToTop', {
          formId: data.formId,
        });
        break;

      case 'scrollFromTop':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_scrollFromTop', {
          formId: data.formId,
          numberOfPixels: data.numberOfPixels
        });
        break;

      case 'inviteLoaded':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_inviteLoaded', {
          formId: data.formId,
          inviteVersion: data.inviteVersion,
          inviteContent: data.inviteContent
        });
        break;

      case 'loadMultipleForms':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_loadMultipileForms', {
          formId: data.formId,
          formIds: data.formIds,
        });
        break;

      case 'routeToForm':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_routeToForm', {
          formId: data.destinationForm, // formId id the new form we want to display
          sourceFormId: data.formId, // sourceFormId is the form that is currently displayed
        }, null, {isStrictMode : true}); // We send the context as null since it isn't needed here
        break;

      case 'submitFeedbackFailed':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_submitFeedbackFailed', data);
        break;

      case 'feedbackUUIDisNull':
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_feedbackUUIDisNull', data);
        break;
      case 'MDigital_Form_Next_Page':
      case 'MDigital_Form_Back_Page':
      case 'MDigital_ThankYou_Displayed':
      case 'MDigital_ThankYou_Close':
      case 'MDigital_Form_Close_No_Submit':
      case 'MDigital_Form_Close_Submitted':
      case 'MDigital_CHTML_Logs':
        KAMPYLE_EVENT_DISPATCHER.trigger(data.action, data);
        break;
      case 'MDigital_Invalid_Origin':
        var notAllowedDomainMessage = 'Message origin domain is not allowed, ';
        var formData = KAMPYLE_DATA.getFormData(data.formId);
        var isPopup = KAMPYLE_DATA.getDisplayType(formData) === KAMPYLE_CONSTANT.DISPLAY_TYPES.POPUP;
        var isInvitation = KAMPYLE_DATA.getFormTriggerType(data.formId) === KAMPYLE_CONSTANT.FORM_TYPES.INVITATION;
        var isSkipInvitation = KAMPYLE_UTILS.getNestedPropertyValue(KAMPYLE_DATA.getFormData(data.formId), 'inviteData.skipInvitation');

        // we want to make sure that form is not displayed in case of invitation, when we use always on we want to display oops page
        if(!isPopup && isInvitation && MDIGITAL_FORM_STATE.isFormShown(data.formId)) {
          KAMPYLE_ONSITE_SDK.closeForm(data.formId);
          console.warn(notAllowedDomainMessage + 'form has been closed!');
        }

        // set form&invite state as invalid to prevent it from being displayed
        KAMPYLE_DATA.setFormState(data.formId, {
          shown: false
        });

        // we want to make sure that we don't display invitation
        var isInviteShown = (KAMPYLE_DATA.getFormState(data.formId) || {}).inviteShown;
        if(isInviteShown) {
          KAMPYLE_VIEW.hideInvite();

          console.warn(notAllowedDomainMessage + 'invitation has been closed!');
        }

        // for popup it is not possible to test domains earlier without showing actual popup, so we force close it after check the domains
        if(isPopup && !isInviteShown) {
          var targetWindow = KAMPYLE_DATA.getMemoryData('popupHandler');

          data.sourceWindow = targetWindow
          KAMPYLE_VIEW.hideForm('MDigital_Invalid_Origin', data);
          console.warn(notAllowedDomainMessage + 'popup has been closed!');
        }

        KAMPYLE_DATA.setMemoryData(KAMPYLE_TARGETING.generateShouldShowInviteParamName(data.formId), false);

        if(isSkipInvitation) {
          KAMPYLE_DATA.setMemoryData('isInvitationShouldBeIgnored', true);
        }

        KAMPYLE_EVENT_DISPATCHER.trigger('MDigital_Invalid_Origin', {formId: data.formId});
        break;
      case 'updateProfileFromExtension':
        window.md_ex_profile = data && data.payload ? data.payload : null;
        if (window.md_ex_profile) {
          var cpMessage = KAMPYLE_FUNC.getCustomParamsMessage(data.formId);
          updateMessageForAllLoadedForms(cpMessage);
          if (window.md_ex_profile.authorizationToken) {
            KAMPYLE_DATA.setAuthorizationToken(window.md_ex_profile.authorizationToken);
            var authorizationMessage = KAMPYLE_MESSAGE.getAuthorizationMessage();
            updateMessageForAllLoadedForms(authorizationMessage);
          }
        }

        if (
          window.md_ex_profile 
          && typeof window.md_ex_profile === "object"
          && Object.keys(window.md_ex_profile).length
        ) {
          KAMPYLE_DATA.initOnsiteDefaultState();
          KAMPYLE_FUNC.startCheckingTargeting();
        }
        break;
      case 'clearProfileFromExtension':
        window.md_ex_profile = null;
        KAMPYLE_DATA.setAuthorizationToken(null);
        break;
      default:
        if (!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ON_PREM_HYBRID)) {
          KAMPYLE_UTILS.showWarning('invalid action - ' + data.action);
        }
        return false;
    }
  }

function getAuthorizationMessage() {
  var message= {
    action: 'setAuthorizationHeader',
    authorizationToken: KAMPYLE_DATA.getAuthorizationToken(),
    __isDigitalAction: true
  };
  return JSON.stringify(message);
}

function updateMessageForAllLoadedForms(messageData) {
  var formsState = KAMPYLE_DATA.getMemoryData('formsState');
  for (var formId in formsState) {
    if (formsState[formId] && formsState[formId].loaded) {
      var formData = KAMPYLE_DATA.getFormData(formId);
      if (!formData || !formData.formDisplay || !formData.formDisplay.displayType) {
        continue;
      }
      if (formData.formDisplay.displayType === 'popup') {
        var targetWindow = KAMPYLE_DATA.getMemoryData('popupHandler');
        targetWindow.postMessage(messageData, '*');
      } else {
        KAMPYLE_UTILS.sendMessageToIframe(KAMPYLE_DATA.getFormIframeId(formId), messageData);
      }
    }
  }
}

  export default {
    init: init,
    updateMessageForAllLoadedForms: updateMessageForAllLoadedForms,
    getAuthorizationMessage: getAuthorizationMessage,

    //For Testing
    handleMessage: handleMessage,
    validateMessageEvent: validateMessageEvent,
    isAllowedSource: isAllowedSource
  };

